<template>
  <div>
    <div class="fixed-top-bar d-flex align-center">
      <v-row>
        <!-- <v-col cols="1">
          <v-btn icon dark disabled="">
            <v-icon size="30"> mdi-arrow-left-bold-box-outline </v-icon>
          </v-btn>
        </v-col> -->
        <!-- <v-col cols="3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class=""
              >
                <v-icon size="30"> mdi-file-plus-outline </v-icon>
              </v-btn>
            </template>
            <span>Add</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-1"
              >
                <v-icon size="30"> mdi-clipboard-edit-outline </v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon dark v-bind="attrs" v-on="on" disabled
              class="ml-1">
                <v-icon size="30"> mdi-eye-outline </v-icon>
              </v-btn>
            </template>
            <span>View</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                dark
                v-bind="attrs"
                v-on="on"
                disabled
                class="ml-1"
              >
                <v-icon size="30"> mdi-delete-outline </v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </v-col>
        <v-col cols="6">
           <v-menu bottom :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" disabled class="ml-1">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </template>
           </v-menu>
           <v-menu bottom :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn dark icon v-bind="attrs" v-on="on" disabled class="ml-1">
                <v-icon>mdi-filter-menu-outline</v-icon>
              </v-btn>
            </template>
           </v-menu>
        </v-col> -->
            <v-col cols="1">
              <v-menu bottom :close-on-content-click="false" content-class="elevation-0" v-model="filter_menu">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn  dark icon v-bind="attrs" v-on="on" class="ml-7 header_btn">
                      <span class="lable_class">Filter</span>
                      <v-icon size="22px" style="color:#bdbdbd" >mdi-filter-menu-outline</v-icon>
                  </v-btn>
                </template> 
                <v-card tile max-width="400" class="mb-5 mr-5" >
                  <v-list class="filter-section-border">
                    <v-list-item class="mt-0 float-right" >
                      <!-- <v-text-field
                        v-model="pagination.search"
                        append-icon="mdi-magnify"
                        label="Search"
                        hide-details
                        dense
                        outlined=""
                        placeholder=" "
                        clearable
                        autofocus
                        v-on:keyup.enter="search_menu = false"
                        class="mr-2"
                      ></v-text-field> -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on" class="error" @click="resetFilter()" icon small><v-icon size="20" class="white--text">mdi-filter-remove-outline</v-icon></v-btn>
                        </template>
                        <span>Reset</span>
                      </v-tooltip>
                    </v-list-item>
                     <v-list-item class="mt-1">
                      
                    </v-list-item>
                    <v-list-item class="mt-1">
                      <v-autocomplete
                        dense
                        flat
                        :items="doc_types_filter"
                        outlined
                        label="Document Type"
                        hide-details
                        class="body-2"
                        placeholder="All"
                        v-model="pagination.filters.doc_type"
                        clearable=""
                      ></v-autocomplete>
                    </v-list-item>
                       <v-list-item class="mt-1">
                      <v-autocomplete
                        dense
                        flat
                        :items="doc_folder_filter"
                        outlined
                        label="Document Folder"
                        hide-details
                        class="body-2"
                        placeholder="All"
                        v-model="pagination.filters.doc_folder"
                        clearable=""
                      ></v-autocomplete>
                    </v-list-item>
                      <v-list-item class="mt-1">
                      <v-autocomplete
                        dense
                        flat
                        outlined
                        label="Report Type"
                        hide-details
                        class="body-2"
                        placeholder="All"
                        v-model="pagination.filters.report_type"
                        clearable=""
                        :items="report_names"
                        item-text="report_name.name"
                        item-value="report_name_id"
                      ></v-autocomplete>
                    </v-list-item>
                  </v-list>
                  <v-card-title class="pa-0">
                      <v-btn
                        fab
                        color="error"
                        x-small
                        absolute
                        @click="filter_menu = false"
                        class="custom-close-btn"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                </v-card>
            </v-menu>
              </v-col>
        <v-col cols="11" class="d-flex align-center justify-end">
          <span class="white--text font-weight-bold">Document View</span>
        </v-col>
      </v-row>
    </div>

    <v-card
      flat
      tile
      :loading="loading"
    >
      <v-card-text
        class="pa-0 mx-auto"
      >
        <v-row dense="" class="pa-0 ma-0">
          <v-col cols="3" class="pa-0 ma-0" style="max-width: 20%">
            <div class="doc-list-menu grey lighten-3">
              <template v-for="item in doc_items.data">
                <v-list-group
                  v-if="item.reports.length > 1"
                  :key="item.doc_id"
                  :value="item.is_expand"
                >
                  <template v-slot:activator>
                    <v-list-item-title @click="loading=true;active_doc_id = item.doc_id;">{{ item.doc_type.title }}</v-list-item-title>
                  </template>
                  <span
                    v-for="childitem in item.reports"
                    :key="childitem.doc_id"
                  >
                    <v-list-item
                      link
                      class="pl-10"
                      v-if="childitem.doc_id != item.doc_id"
                      @click="loading=true;active_doc_id = childitem.doc_id"
                      :class="(childitem.doc_id == active_doc_id)?'v-list-item--active':''"
                    >
                      <v-list-item-title>{{ childitem.doc_type.title }}<br/><span style="font-size:10px;">({{ childitem.client_name }})</span></v-list-item-title>
                    </v-list-item>
                  </span>
                </v-list-group>
                <v-list-item
                  :key="item.doc_id"
                  link
                  v-else
                  @click="loading=true;active_doc_id = item.doc_id"
                  :class="(item.doc_id == active_doc_id)?'v-list-item--active':''"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ item.doc_type.title }}<br/> <span style="font-size:10px;">({{ item.client_name }})</span></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </div>
          </v-col>
          <v-col class="pa-0 ma-0">
            <div v-for="(slide, index) in doc_items.data" :key="index">
              <div v-if="slide.doc_id == active_doc_id" :class="(isMsDoc(slide.doc_path) || isGoogleDoc(slide.doc_path, slide.report_name_id))?'':'d-flex align-center justify-center'" style="height: 795px;">
                <img
                  :src="slide.dropbox_url"
                  v-if="isImage(slide.doc_path)"
                  style="max-height:790px;"
                   @load="loading=false"
                />
                <div v-else-if="isMsDoc(slide.doc_path)">
                  <iframe
                    :src="'https://view.officeapps.live.com/op/embed.aspx?src='+slide.dropbox_url"
                    frameborder="0"
                    style="width:100%;height:790px"
                    @load="loading=false"
                  ></iframe>
                </div>
                <div v-else-if="isGoogleDoc(slide.doc_path, slide.report_name_id)">
                  <iframe
                    :src="'https://docs.google.com/gview?embedded=true&url='+slide.dropbox_url"
                    frameborder="0"
                    style="width:100%;height:790px"
                    @load="loading=false"
                  ></iframe>
                </div>
                <img
                  v-else
                  src="/images/no-preview.png"
                  style="max-height:790px;"
                />
              </div>
            </div>
          </v-col>
          <!-- <v-col class="pa-0 ma-0">
            <div v-for="(slide, index) in doc_items.data" :key="index">
              <div v-if="slide.doc_id == active_doc_id" :class="(isImage(slide.doc_path))?'d-flex align-center justify-center':''" style="height: 100vh;">
                <img
                  :src="slide.doc_path"
                  v-if="isImage(slide.doc_path)"
                  style="max-height:100vh;"
                />
                <div v-else-if="isMsDoc(slide.doc_path)">
                  <iframe
                    :src="'https://view.officeapps.live.com/op/embed.aspx?src='+slide.doc_path"
                    frameborder="0"
                    style="width:100%;height:100vh"
                  ></iframe>
                </div>
                <div v-else-if="isGoogleDoc(slide.doc_path)">
                  <iframe
                    :src="'https://docs.google.com/gview?embedded=true&url='+slide.doc_path"
                    frameborder="0"
                    style="width:100%;height:100vh"
                  ></iframe>
                </div>
                <img
                  v-else
                  src="/images/no-preview.png"
                  style="max-height:100vh;"
                />
              </div>
            </div>
          </v-col> -->
        </v-row>
      </v-card-text>
    </v-card>
     <v-overlay absolute :value="loading">
          <v-icon style="font-size: 80px;">mdi-progress-clock mdi-spin</v-icon>
    </v-overlay>
  
  </div>
</template>
<script>
import axios from "../../plugins/axios";
import { parseParams } from "../../plugins/helper";

export default {
  name: "UploadList",
  data() {
    return {
      showSlider: true,
      itemNumber: 0,
      drawer: false,
      doc_items: [],
      loading: false,
      active_doc_id: this.$route.params.doc_id,
      filter_menu: false,
      pagination: {
        itemsPerPage: 20,
        sortBy: ["created_at"],
        page: 1,
        search: '',
        filters: {
          doc_type: this.$route.params.doc_type,
          doc_folder:this.$route.params.doc_folder,
          report_type:"",
          doc_module_status:""
        },
      },
    report_names:[],
      doc_folder_filter:[],
      doc_types_filter:[],
    };
  },
   watch: {
    pagination: {
      handler() {
        this.getDocumentData(parseParams(this.pageData));
        this.getDocTypes(parseParams(this.pageData));
      },
      deep: true,
    },
  },
  computed:{
     pageData() {
      let paginationData = this.pagination;
      return paginationData;
    },
    
  },
  methods: {
    closeTab() {
      window.close();
    },
    resetFilter() {
      this.pagination.search = ""
      this.pagination.filters.report_type = ""
      this.pagination.filters.doc_type = ""
      this.pagination.filters.doc_folder = ""
      this.pagination.filters.doc_module_status = ""
      this.getDocumentData(parseParams(this.pageData));
    },
    
    getExtension(path) {
      let splitPath = path.split(".");
      splitPath = splitPath[splitPath.length - 1];
      return splitPath;
    },
    isImage(path) {
      if (
        ["png", "jpeg", "jpg", "bmp", "svg"].includes(this.getExtension(path))
      ) {
        return true;
      } else {
        return false;
      }
    },
    isGoogleDoc(path,report_name_id) {
      if (["pdf", "txt", "rtf"].includes(this.getExtension(path)) || report_name_id > 0) {
        return true;
      } else {
        return false;
      }
    },
    isMsDoc(path) {
      if (
        ["csv", "doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(
          this.getExtension(path)
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    getDocumentData(data) {
      let _self = this;
      this.loading = true;
      axios
      .get('document/list?type='+this.$route.params.type+'&o_id='+this.$route.params.o_id+'&'+data)
      .then(res => {
        let data = res.data
        _self.doc_items = data.data;
        for(let i = 0; i<_self.doc_items.data.length;i++) {
          _self.doc_items.data[i].is_expand = false;
          for(let k = 0; k<_self.doc_items.data[i].reports.length;k++) {
            if(_self.doc_items.data[i].reports[k].doc_id == _self.active_doc_id) {
              _self.doc_items.data[i].is_expand = true;
            }
          }
        }
        _self.loading = false;
      })
      .catch(function(error) {
        console.log(error);
        _self.loading = false;
      });
    },
    getDocTypes(data){
       let _self = this;
      this.loading = true;
      axios
      .get('get_doc_types?doc_module='+this.$route.params.type+'&f_o_id='+this.$route.params.o_id+'&'+data)
      .then(res => {
        let data = res.data
        _self.doc_types_filter=data.data_filter
        _self.doc_folder_filter=data.data_folder_filter
        _self.loading = false;
      })
      .catch(function(error) {
        console.log(error);
        _self.loading = false;
      });

    },
  getReportName(){
    let _self = this;
    axios.get('get_report_names?o_id='+this.$route.params.o_id)
    .then(function(res){
     _self.report_name=res.data.data
     
    })
  },
  },
  mounted: function () {
    this.pagination.filters.doc_type = this.$route.params.doc_type
    this.pagination.filters.doc_folder = this.$route.params.doc_folder
    this.getDocumentData(parseParams(this.pageData));
    this.getDocTypes(parseParams(this.pageData));
    this.getReportName();
  }
}
</script>
<style scoped>
.doc-list-menu .v-list-item{
  max-height: 55px !important;
}
</style>